import { render, staticRenderFns } from "./ReviewsCarousel.vue?vue&type=template&id=ea696296&scoped=true"
import script from "./ReviewsCarousel.vue?vue&type=script&lang=js"
export * from "./ReviewsCarousel.vue?vue&type=script&lang=js"
import style0 from "./ReviewsCarousel.vue?vue&type=style&index=0&id=ea696296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea696296",
  null
  
)

export default component.exports